import {Component, OnInit, ViewChild} from '@angular/core';
import {PublicationModel, PublicationSaveModel} from '../../models/publication.model';
import {Router} from '@angular/router';
import {
    StepSummaryRegistrationComponent
} from '../../components/publication-registration/step-summary-registration/step-summary-registration.component';
import {StepNewPublicationComponent} from '../../components/publication-registration/step-new-publication/step-new-publication.component';
import {PublicationService} from '../../services/publication.service';
import {NotificationService} from '../../../shared/utils/notification.service';
import {I18nService} from '../../../shared/i18n';
import {ConfirmationService} from 'primeng/api';
import {UserService} from '../../services/user.service';
import {AppCommunicationService} from '../../services/app-communication.service';

@Component({
    selector: 'app-publication-registration-view',
    templateUrl: './publication-registration-view.component.html',
    styleUrls: ['./publication-registration-view.component.scss']
})
export class PublicationRegistrationViewComponent implements OnInit {
    saving = false;
    loggedUser: any;
    publication: PublicationModel = new PublicationModel();
    steps = [
        {
            key: 'step1',
            title: 'registrationInformation',
            valid: false,
            checked: false
        },
        {
            key: 'step2',
            title: 'publicationInformation',
            valid: false,
            checked: false
        },
        {
            key: 'step3',
            title: 'summary',
            valid: false,
            checked: false
        },
        {
            key: 'step4',
            title: 'done',
            valid: true,
            checked: false
        },
    ];
    activeStep = this.steps[0];
    buttons = {
        next: {
            name: 'continue',
            visible: true
        },
        back: {
            name: 'back',
            visible: false
        }
    };

    @ViewChild(StepSummaryRegistrationComponent) stepSummaryRegistrationComponent: StepSummaryRegistrationComponent;
    @ViewChild(StepNewPublicationComponent) stepNewPublicationComponent: StepNewPublicationComponent;

    constructor(private router: Router,
                private userService: UserService,
                private publicationService: PublicationService,
                private notificationService: NotificationService,
                private confirmationService: ConfirmationService,
                private i18nService: I18nService) {
    }

    ngOnInit() {
        this.loggedUser = AppCommunicationService.getCurrentUser().user;
    }

    setButtons() {
        const idx = this.steps.indexOf(this.activeStep);
        switch (idx) {
            case 0:
                this.buttons.back.visible = false;
                this.buttons.next.visible = true;
                this.buttons.next.name = 'continue';
                break;
            case 3:
                this.buttons.next.name = 'close';
                this.buttons.next.visible = true;
                this.buttons.back.visible = false;
                break;
            default:
                this.buttons.back.visible = true;
                this.buttons.next.visible = true;
                this.buttons.next.name = 'continue';
                this.buttons.back.name = 'back';
        }
    }

    prevStep() {
        const idx = this.steps.indexOf(this.activeStep);
        switch (idx) {
            case 0:
                break;
            case 2:
                this.activeStep = this.steps[idx - 1];
                this.stepSummaryRegistrationComponent.resetComponent();
                break;
            default:
                this.activeStep = this.steps[idx - 1];
        }
        this.setButtons();
    }

    nextStep() {
        const idx = this.steps.indexOf(this.activeStep);
        if (!this.activeStep.valid) {
            return;
        }
        this.activeStep.checked = true;
        switch (idx) {
            case 0:
                this.activeStep = this.steps[idx + 1];
                break;
            case 1:

                if (this.publication.documentType.id === 4 && this.publication.printCount < 50) {
                    this.notificationService.smartMessageBox({
                        title: this.i18nService.getTranslation('confirmation'),
                        content: this.i18nService.getTranslation('confirmLowSupply'),
                        buttons: '[' + this.i18nService.getTranslation('No') + '][' +
                            this.i18nService.getTranslation('Yes') + ']'
                    }, (ButtonPressed) => {
                        if (ButtonPressed === this.i18nService.getTranslation('Yes')) {
                            this.activeStep = this.steps[idx + 1];
                        }
                    });
                    break;
                } else {
                    this.activeStep = this.steps[idx + 1];
                    break;
                }

            case 2:
                if (!this.saving) {
                    if (this.publication.documentType.id === 4 && this.publication.printCount < 50) {
                        this.notificationService.smartMessageBox({
                            title: this.i18nService.getTranslation('confirmation'),
                            content: this.i18nService.getTranslation('confirmLowSupply'),
                            buttons: '[' + this.i18nService.getTranslation('No') + '][' +
                                this.i18nService.getTranslation('Yes') + ']'
                        }, (ButtonPressed) => {
                            if (ButtonPressed === this.i18nService.getTranslation('Yes')) {
                                this.buttons.next.visible = false;
                                this.buttons.back.visible = false;
                                this.saving = true;
                                this.submitPublication();
                                return;
                            }
                        });
                    } else {
                        this.buttons.next.visible = false;
                        this.buttons.back.visible = false;
                        this.saving = true;
                        this.submitPublication();
                        return;
                    }
                }
                this.activeStep = this.steps[idx + 1];
                this.activeStep.checked = true;
                break;
        }
        this.setButtons();

    }

    onStepValidityChange(idex: number, $event) {
        this.steps[idex].valid = $event;
    }

    redirectToDashboard() {
        this.router.navigate(['/dashboard']);
    }

    submitPublication() {
        this.publicationService.createPublication(new PublicationSaveModel(this.publication)).subscribe(
            () => this.onSavingSuccesfully(), err => {
                console.error(err);
                this.onSavingError();
            }
        )
    }

    onModelChanged(_publication: PublicationModel) {
        this.publication = _publication;
    }

    onSavingSuccesfully() {
        this.nextStep();
        this.saving = false;
        // this.setButtons()
    }

    onSavingError() {
        this.notificationService.smallBox({
            title: this.i18nService.getTranslation('error'),
            color: '#923837',
            iconSmall: 'fa fa-warning fa-2x fadeInRight animated',
            content: this.i18nService.getTranslation('somethingIsWrongError'),
            timeout: 10000
        });
        this.saving = false;
        this.setButtons()
    }

}



// WEBPACK FOOTER //
// ./src/app/+app-custom/views/publication-registration-view/publication-registration-view.component.ts